import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifInput,
  MotifFormField,
  MotifErrorMessage,
} from '@ey-xd/motif-react';
import { Field, reduxForm } from 'redux-form';
import * as formHelpers from '../../scripts/formHelpers';

const DeleteREITConfirmationModal = ({
  showDeleteREITConfirmationModal,
  toggleShowDeleteREITConfirmationModal,
  handleConfirm,
  apiErrorMessage,
  handleDismissErrorMessage,
}) => {
  const [confirmationInputText, setConfirmationInputText] = useState('');
  const [saveEnabled, setSaveEnabled] = useState(false);

  useEffect(() => {
    if (showDeleteREITConfirmationModal) {
      setConfirmationInputText('');
      setSaveEnabled(false);
    }
  }, [showDeleteREITConfirmationModal]);

  const handleConfirmationInput = (e) => {
    let inputValue = e.target.value.trim();
    setConfirmationInputText(inputValue);
    if (inputValue.toLowerCase() === 'delete') {
      setSaveEnabled(true);
    } else {
      setSaveEnabled(false);
    }
  };

  const showHideConfirmationModal = () => {
    setConfirmationInputText('');
    toggleShowDeleteREITConfirmationModal();
  };

  const closeButtonProps = {
    title: 'Delete REIT',
    'aria-label': 'Delete REIT',
    'data-testid': 'close',
  };

  return (
    <MotifModal
      show={showDeleteREITConfirmationModal}
      data-testid="divDeleteReitModal"
      onClose={showHideConfirmationModal}
      variant="default"
      size="lg"
    >
      <MotifModalHeader
        closeButtonProps={closeButtonProps}
        data-testid="mdHdrDeleteReit"
      >
        Delete REIT
      </MotifModalHeader>
      <MotifModalBody>
        {formHelpers.showSubmissionError(
          apiErrorMessage,
          handleDismissErrorMessage
        )}
        <MotifFormField>
          <div className="row">
            <div className="field col-md-12">
              <Field
                name="reitName"
                component={formHelpers.renderField}
                type="text"
                label="REIT Name"
                dataTestId="txtReitName"
                className="w-100"
                disabled={true}
              />
            </div>
          </div>
        </MotifFormField>
        <span className="margin-bottom-1">
          Type &apos;Delete&apos; in the box below to confirm you want to make
          this change.
        </span>
        <div className="row">
          <div className="field col-md-12">
            <MotifInput
              type="text"
              name="confirmationInput"
              id="confirmationInput"
              onChange={handleConfirmationInput}
              value={confirmationInputText}
              required={true}
              placeholder="Delete"
              data-testid="txtDelete"
            />
          </div>
        </div>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          variant="secondary"
          className="right mt-3"
          onClick={() => {
            setConfirmationInputText('');
            toggleShowDeleteREITConfirmationModal();
          }}
          data-testid="btnCancel"
          type="button"
        >
          Cancel
        </MotifButton>
        <MotifButton
          variant="primary"
          className="right mt-3"
          data-testid="btnConfirm"
          onClick={handleConfirm}
          type="button"
          disabled={!saveEnabled}
        >
          Confirm
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

DeleteREITConfirmationModal.propTypes = {
  showDeleteREITConfirmationModal: PropTypes.bool,
  toggleShowDeleteREITConfirmationModal: PropTypes.func,
  handleConfirm: PropTypes.func,
  deleteREIT: PropTypes.func,
  initialValues: PropTypes.shape({
    reitid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    reitName: PropTypes.string,
  }),
  apiErrorMessage: PropTypes.string,
};
export default reduxForm({
  form: 'deleteREITForm',
  enableReinitialize: true,
})(DeleteREITConfirmationModal);
